/**
 * GLOBAL PRODUCT CATALOG — the single source of truth for what Drivons
 * offers, in every country, in every language.
 *
 * Product ≠ Pricing.
 *   • The catalog below defines the product: 10 categories × N option_codes.
 *   • Pricing rules (per-country, in the DB) decide *how much* each option
 *     costs in a specific country — never *whether* the option exists.
 *
 * Do NOT branch this catalog by country. Do NOT add legacy option_codes
 * that were only ever used by a single country (e.g. TR-only room-based
 * moving codes `1plus1`/`villa` — those are pricing-catalog entries, not
 * product-catalog entries, and are hidden from the customer UI).
 */
export const GLOBAL_PRODUCT = {
  taxi:    ["regular", "hybrid", "7seats", "vip"],
  delivery:["motorcycle", "car"],
  moving:  ["small_van", "medium_truck", "large_truck", "xl_truck", "refrigerated_van", "refrigerated_truck"],
  towing:  ["1t", "3.5t", "3.5_to_7.5t", "over_7.5t", "12t_plus"],
  mechanic:["standard"],
  tire:    ["roadside_repair"],
  carwash: ["exterior", "exterior_interior", "premium"],
  bus:     ["minivan", "minibus", "bus_standard"],
  luxury:  ["luxury_4_seats", "luxury_8_seats"],
  crane:   ["crane_12_18m", "crane_18_24m", "crane_24_42m", "crane_42m_plus"],
};

/** Ordered list of the 10 customer-facing categories. Global. */
export const GLOBAL_CATEGORIES = Object.keys(GLOBAL_PRODUCT);

/** True when the given option_code is part of the global product catalog. */
export function isGlobalOption(category, optionCode) {
  const list = GLOBAL_PRODUCT[category];
  return Array.isArray(list) && list.includes(optionCode);
}

/** Sort helper — returns global-catalog index (or Infinity if unknown). */
export function catalogOrderIndex(category, optionCode) {
  const list = GLOBAL_PRODUCT[category] || [];
  const i = list.indexOf(optionCode);
  return i === -1 ? Number.POSITIVE_INFINITY : i;
}
